import { findOptionIndex } from './selectUtils';

export function normalizeValues(values) {
  return (values ?? []).map(String);
}

export function getSelectedLabels({ normalizedOptions, normalizedValues }) {
  if (normalizedValues.length === 0) return [];
  const set = new Set(normalizedValues);
  return normalizedOptions
    .filter((opt) => set.has(String(opt.value)))
    .map((opt) => ({ value: String(opt.value), label: opt.label }));
}

export function getSelectedIndex({ normalizedOptions, normalizedValues }) {
  const first = normalizedValues[0];
  if (!first) return 0;
  const idx = findOptionIndex(normalizedOptions, first);
  return Math.max(0, idx);
}

export function toggleMultiValue({ normalizedValues, nextValue }) {
  const key = String(nextValue);
  const set = new Set(normalizedValues);
  if (set.has(key)) set.delete(key);
  else set.add(key);
  return Array.from(set);
}

export function getForceSurfaceBg({ variant, filledBg, isEmpty }) {
  return variant === 'form' && !isEmpty && filledBg === 'surface';
}
